<template>
  <div class="login-wrap">
    <div class="top">手机快捷登录</div>
    <div class="content">
      <div class="title">手机号码</div>
      <div class="fieldBox">
        <div>
          <van-field
            v-model="phone"
            maxlength="11"
            placeholder="请输入您的手机号码"
            type="digit"
          />
        </div>
        <div
          v-if="phone"
          @click="deletePhone"
        >
          <img
            class="delete"
            src="@/assets/img/car-life/ic_delete_code.png"
          >
        </div>
      </div>

      <div
        class="title"
        style="margin-top: 24px"
      >验证码</div>
      <div class="fieldBox">
        <div class="field-wrapper">
          <van-field
            v-model="code"
            maxlength="6"
            placeholder="请输入验证码"
            type="digit"
          />
        </div>
        <div
          class="code"
          :class="{ disable: codeDisable }"
          @click="sendCodeClick"
        >
          {{ codeTitle }}
        </div>
      </div>
      <van-button
        class="submit"
        :disabled="isDisabled"
        type="info"
        @click="submitClick"
      >提交</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { getCode, codeLogin, vasCommonCheckToken, carList } from '@/common/api.js';
import { cookieSet, cookieRemove } from '@/common/cookie';
import { MobileRegExp } from '@/common/regex.js';

// 限制字符输入规则
import { mixins } from '@/mixins/replaceInput';
import { debounce } from 'lodash';

export default {
  mixins: [mixins],
  data() {
    return {
      phone: '',
      code: '',
      timer: null,
      codeTitle: '获取验证码',
      codeDisable: false,
      categoryCode: '', // 外部跳转，用这个字段来区分
      categoryMap: {
        phoneCharge: 'FL00000002', // 话费充值
        akeyRefuel: 'FL20000002', // 一键加油
        giftCard: 'FL30000002', // 礼品卡
        refuel: 'FL00000003', // 加油卡充值
        mediacard: 'FL30000003', // 视听卡
        ticket: 'FL80000003', // 罚单
        parkViolations: 'FL80000002' // 违章
      }
    };
  },
  computed: {
    isDisabled() {
      if (this.code && this.code.length > 0 && this.phone && this.phone.length > 0) {
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.tokenTime();
    this.init();
  },

  methods: {
    init() {
      // 外部跳转过来的
      if (this.$route.query.categoryCode) {
        this.categoryCode = this.$route.query.categoryCode;
      }
      if (this.$route.query.phone) {
        this.phone = this.$route.query.phone;
      }
    },
    countDown() {
      this.countDownSecond--;
      if (this.countDownSecond < 0) {
        clearInterval(this.timer);
        this.codeTitle = '获取验证码';
        this.codeDisable = false;
        return;
      }
      this.codeTitle = '获取验证码' + this.countDownSecond + 's';
    },
    sendCodeClick: debounce(
      async function() {
        // 验证码不可点击
        if (this.codeDisable) {
          return;
        }
        if (!this.phone) {
          Toast('手机号不能为空');
          return;
        }
        if (this.phone.length != 11 || !MobileRegExp.test(this.phone)) {
          Toast('请输入正确的手机号');
          return;
        }
        try {
          const res = await getCode({ phone: this.phone });
          this.codeDisable = true;
          Toast('获取验证码成功');
          this.countDownSecond = 60;
          this.timer = setInterval(this.countDown, 1000);
        } catch (error) {}
      },
      3000,
      { leading: true, trailing: false }
    ),
    deletePhone() {
      this.phone = '';
    },
    deleteCode() {
      this.code = '';
    },
    submitClick: debounce(
      async function() {
        if (this.phone.length != 11 || !MobileRegExp.test(this.phone)) {
          Toast('请输入正确的手机号');
          return;
        }
        try {
          const res = await codeLogin({ phone: this.phone, code: this.code });
          if (
            document.domain.indexOf('vas') > -1 ||
            document.domain.indexOf('zengzhi') > -1 ||
            document.domain.indexOf('localhost') > -1
          ) {
            cookieSet('token', res);
            cookieSet('phone', this.phone);

            // cookieSet("signKey", JSON.parse(res.data.data).signKey, {
            //   domain: window.location.hostname,
            // });
          }
          localStorage.setItem('_phone', this.phone);
          if (this.categoryCode) {
            this.externalJump();
          } else {
            this.$router.push({
              path: '/carLife',
              query: {
                phone: this.phone
              }
            });
          }
        } catch (error) {}
      },
      3000,
      { leading: true, trailing: false }
    ),
    async tokenTime() {
      try {
        // await vasCommonCheckToken({}).then((res) => {
        //   this.$router.push("phoneCharge");
        // });
      } catch (error) {}
    },

    async externalJump() {
      let path = '';
      if (this.categoryCode === this.categoryMap.phoneCharge) {
        path = '/phoneCharge';
      } else if (this.categoryCode === this.categoryMap.akeyRefuel) {
        path = '/akeyRefuel';
      } else if (this.categoryCode === this.categoryMap.ticket) {
        path = '/ticketCheck';
      } else if (this.categoryCode === this.categoryMap.parkViolations) {
        const phone = this.$route.query.phone || this.phone;
        const res = await carList({ phone: phone });
        path = res.length > 0 ? '/parkingViolationsCheck' : '/carCheck';
      } else if (this.categoryCode === this.categoryMap.mediacard) {
        path = '/mediaCharge';
      } else if (this.categoryCode === this.categoryMap.refuel) {
        path = '/refuelRecharge';
      } else if (this.categoryCode === this.categoryMap.giftCard) {
        path = '/giftSelectProduct';
      }
      if (path) {
        this.$router.push({
          path: path,
          query: {
            phone: this.$route.query.phone || this.phone,
            categoryCode: this.categoryCode
          }
        });
      }
    }
  },

  destroyed() {
    try {
      if (this.timer) {
        clearInterval(this.timer);
      }
    } catch (error) {}
  }
};
</script>

<style lang="scss">
.login-wrap {
  .van-cell {
    padding-left: 0px;
  }
}
</style>

<style lang="scss" scoped>
.login-wrap {
  width: 7.5rem;
  height: 100wh;
  background-color: white;
}

.top {
  font-size: 0.48rem;
  color: #383838;
  margin-left: 0.6rem;
  margin-top: 0.96rem;
}

.content {
  margin-left: 0.6rem;
  width: 6.3rem;
  margin-top: 1.12rem;
  display: flex;
  font-size: 0.32rem;
  flex-direction: column;
}

.fieldBox {
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  font-size: 0.32rem;
  color: #383838;
  flex: 1;

  .delete {
    height: 0.4rem;
    width: 0.4rem;
  }

  .field-wrapper {
    flex: 1;
  }

  .code {
    color: #3399ff;

    &.disable {
      color: #b3d9ff;
    }
  }
}

.title {
  color: #646464;
  font-size: 0.3rem;
  margin-bottom: 0.32rem;
}

.submit {
  margin-top: 1.45rem;
  width: 6.3rem;
  height: 0.96rem;
  font-size: 0.32rem;
}
</style>
